// extracted by mini-css-extract-plugin
module.exports = {"error":"Input_error__UYW8s","errorMsg":"Input_errorMsg__uhFzw","iconSearch":"Input_iconSearch___T0_R"};